import { apiFetch } from '@/lib/api/http';
import type { OfficeGrade } from '@/features/auth/api';

/**
 * 事務局アカウント（指示書 §5.1 / §10）。
 * 管理責任者を0人にする操作・自己降格・自己停止はAPI側で拒否される。
 */
export interface OfficeAccount {
  user_id: string;
  email: string;
  display_name: string | null;
  office_grade: OfficeGrade;
  is_active: boolean;
  totp_enrolled: boolean;
  last_login_at: string | null;
}

export function fetchOfficeAccounts(): Promise<OfficeAccount[]> {
  return apiFetch<OfficeAccount[]>('/office-accounts');
}

export function changeOfficeGrade(userId: string, grade: OfficeGrade): Promise<void> {
  return apiFetch<void>(`/office-accounts/${userId}/grade`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ office_grade: grade }),
  });
}

export function changeOfficeStatus(userId: string, isActive: boolean): Promise<void> {
  return apiFetch<void>(`/office-accounts/${userId}/status`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ is_active: isActive }),
  });
}
